import {Route, Routes} from "react-router-dom";
import React from "react";
import {ProtectedRoute} from "../auth";
import {ClientsManagementProvider} from "../features/management-v2/clients/ClientsManagementContext";
import ClientList from "../features/management-v2/clients/ClientList";
import ClientCreate from "../features/management-v2/clients/ClientCreate";
import ClientEdit from "../features/management-v2/clients/ClientEdit";
import {DepartmentsManagementProvider} from "../features/management-v2/departments/DepartmentsManagementContext";
import DepartmentList from "../features/management-v2/departments/DepartmentList";
import DepartmentCreate from "../features/management-v2/departments/DepartmentCreate";
import DepartmentEdit from "../features/management-v2/departments/DepartmentEdit";
import DepartmentGuardians from "../features/management-v2/departments/DepartmentGuardians";
import {InvitationsManagementProvider} from "../features/management-v2/invitations/InvitationsManagementContext";
import InvitationList from "../features/management-v2/invitations/InvitationList";
import {ImportContextProvider} from "../features/management-v2/import/ImportContextProvider";
import {ImportPage} from "../features/management-v2/import/ImportPage";
import {UsersManagementProvider} from "../features/management-v2/users/UsersManagementContext";
import UserList from "../features/management-v2/users/UserList";
import UserCreate from "../features/management-v2/users/UserCreate";
import UserEdit from "../features/management-v2/users/UserEdit";
import {ClientCustomisation} from "../features/management-v2/ClientCustomisation";
import { UserManagementBrowsingProvider } from "../lib/user-management/UserManagementBrowsingContext";
import DeviceCreate from "../features/management-v2/devices/DeviceCreate";
import DeviceEdit from "../features/management-v2/devices/DeviceEdit";
import DeviceList from "../features/management-v2/devices/DeviceList";
import { DevicesManagementProvider } from "../features/management-v2/devices/DevicesManagementContext";
import { ImportDevicesPage } from "../features/management-v2/importDevices/importDevicesPage";
import { ImportDevicesContextProvider } from "../features/management-v2/importDevices/ImportDevicesContextProvider";
import UserEditWrapped from "@/features/management-v2/users/UserEditWrapped";
import NotificationGroupList from "../features/management-v2/notification-groups/NotificationGroupList";
import NotificationGroupCreate from "../features/management-v2/notification-groups/NotificationGroupCreate";
import NotificationGroupEdit from "../features/management-v2/notification-groups/NotificationGroupEdit";
import {CustomUserFieldsPage} from "@/features/management-v2/custom-user-fields/CustomUserFieldsPage";

export const ManagementRoutes = () => {
    return (
        <UserManagementBrowsingProvider>
            <Routes>
                <Route
                    path="clients"
                    element={
                        <ProtectedRoute>
                            <ClientsManagementProvider>
                                <ClientList/>
                            </ClientsManagementProvider>

                        </ProtectedRoute>
                    }
                />
                <Route
                    path="clients/create"
                    element={
                        <ProtectedRoute>
                            <ClientCreate/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="clients/edit/:id"
                    element={
                        <ProtectedRoute>
                            <ClientEdit/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="departments"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <DepartmentsManagementProvider>
                                <DepartmentList/>
                            </DepartmentsManagementProvider>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="departments/create"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <DepartmentCreate/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="departments/edit/:id"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <DepartmentEdit/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="departments/:id/guardians"
                    element={
                        <ProtectedRoute>
                            <DepartmentGuardians/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="invitations"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <InvitationsManagementProvider>
                                <InvitationList/>
                            </InvitationsManagementProvider>
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="import"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <ImportContextProvider>
                                <ImportPage/>
                            </ImportContextProvider>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="import-devices"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <ImportDevicesContextProvider>
                                <ImportDevicesPage/>
                            </ImportDevicesContextProvider>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="users"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <UsersManagementProvider>
                                <UserList/>
                            </UsersManagementProvider>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="users/create"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            {/* eslint-disable-next-line react/jsx-no-undef */}
                            <UserCreate/>
                        </ProtectedRoute>
                    }
                />
                    <Route
                    path="users/edit/:id"
                    element={
                        <ProtectedRoute accessLevel="user">
                        <UserEditWrapped />
                        </ProtectedRoute>
                    }
                    />

                <Route
                    path="customisation"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <ClientCustomisation/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="devices"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                          <DevicesManagementProvider>
                            <DeviceList />
                            </DevicesManagementProvider>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="devices/create"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            {/* eslint-disable-next-line react/jsx-no-undef */}
                            <DeviceCreate/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="devices/edit/:id"
                    element={
                        <ProtectedRoute accessLevel={"user"}>
                            <DeviceEdit/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="custom-user-fields"
                    element={
                        <ProtectedRoute accessLevel={"client"}>
                            <CustomUserFieldsPage/>
                        </ProtectedRoute>
                    }
                    />

                <Route
                    path="notification-groups"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <NotificationGroupList/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="notification-groups/create"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <NotificationGroupCreate/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="notification-groups/edit/:id"
                    element={
                        <ProtectedRoute accessLevel={"department"}>
                            <NotificationGroupEdit/>
                        </ProtectedRoute>
                    }
                />

            </Routes>
        </UserManagementBrowsingProvider>)
}
